import React from 'react';
import classnames from 'classnames/bind';

import BasicButton from '@COMPONENTS/COMMON/buttons/BasicButton';

import styles from './DocumentIntroductionEmptyState.module.scss';

const cx: CX = classnames.bind(styles);

interface DocumentIntroductionEmptyStateProps {
    onAddIntroduction: () => void;
    canEdit: boolean;
    context?: 'document' | 'chapter';
}

function DocumentIntroductionEmptyState({ onAddIntroduction, canEdit, context = 'document' }: DocumentIntroductionEmptyStateProps) {
    const getIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
            <polyline points="14,2 14,8 20,8" />
            <path d="M8 13h8M8 17h6" />
            <circle cx="10" cy="10" r="1" fill="currentColor" />
        </svg>
    );

    return (
        <div className={cx('document-introduction-empty-state')}>
            <div className={cx('content')}>
                <div className={cx('left-section')}>
                    <div className={cx('icon-container')}>
                        {getIcon()}
                    </div>
                    <div className={cx('text-content')}>
                        <h4 className={cx('title')}>
                            {context === 'chapter' ? 'No Chapter Introduction' : 'No Introduction Text'}
                        </h4>
                        <p className={cx('description')}>
                            {context === 'chapter' 
                                ? 'Add a chapter introduction that will appear at the beginning of the chapter in the PDF document.' 
                                : 'Add an introduction that will appear above the table of contents in the PDF document.'}
                        </p>
                    </div>
                </div>
                {canEdit && (
                    <div className={cx('right-section')}>
                        <BasicButton
                            title={context === 'chapter' ? 'Add Chapter Introduction' : 'Add Introduction'}
                            variant="neutral"
                            size="medium"
                            onClick={onAddIntroduction}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

DocumentIntroductionEmptyState.defaultProps = {
    context: 'document',
};

export default DocumentIntroductionEmptyState; 